import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import camelcaseKeys from 'camelcase-keys';
import {
  PageTitle,
  PseudoStates,
  useFeatures,
  useFetch,
} from '@cordata/buffet';

import usePatient from '~/utils/patient/hook';
import { CitProvider } from '~/utils/cit/context';
import CitForm from '~/components/CIT/Form';
import PDFDownloadButton from '~/components/common/PDFDownloadButton';

const MedicalEventsCitDetails = () => {
  const params = useParams();
  const { hasSupervisoryApproval } = useFeatures();
  const [formValues, setFormValues] = useState({});
  const [status, setStatus] = useState();

  const [, patient] = usePatient();
  const [s, data] = useFetch(`medical-events/${params.medical_event_id}`);

  useEffect(() => {
    if (data) {
      setStatus('loading');
      setFormValues({});

      const submissionPayload = data?.attributes?.details?.find(i => i.name === 'submission_payload')?.value;
      let detailObject = {};
      try {
        setStatus(s);
        detailObject = camelcaseKeys(JSON.parse(submissionPayload));
      } catch (error) {
        console.error(error);
      }

      if (hasSupervisoryApproval) { detailObject.approvalStatus = 'approved'; }

      setFormValues({
        id: data.id,
        ...detailObject,
        locationLatitude: data.relationships?.location?.attributes?.latitude,
        locationLongitude: data.relationships?.location?.attributes?.longitude,
      });

      setStatus('success');
    }
  }, [data]);

  return status === 'success' ? (
    <>
      <div>
        <PageTitle
          action={
            <PDFDownloadButton
              endpoint={`/api/data/public/patient/${patient.id}/medical-events/${params.medical_event_id}/pdf`}
            />
          }
        >
          Crisis Interventions
        </PageTitle>
      </div>
      <CitProvider>
        <CitForm
          data={formValues}
          disabled
        />
      </CitProvider>
    </>
  ) : (
    <PseudoStates isLoading={status === 'loading'} error={status === 'error'} />
  );
};

export default MedicalEventsCitDetails;
